export const auth = ({ next, router }) => {
  const token = localStorage.getItem('token');  
  if (!token) {
      return router.push("/login/");
  }
  return next();
}